import { Navbar, SideBar } from "components"
import { useState } from "react"
import { Box } from "theme-ui"

export const Hamburger = () => {
 // state for hamburger opening
 const [menuOpen, setMenuOpen] = useState<boolean>(false)
 // state for navbar
 const [navbar, setNavbar] = useState<boolean>(true)
 // state for sideBar opening
 const [sideBar, setSideBar] = useState<boolean>(false)

 // method for showing navbar
 const openNav = () => {
  setNavbar(true)
  setSideBar(false)
 }
 // method for showing sideBar
 const openSideBar = () => {
  setNavbar(false)
  setSideBar(true)
 }
 return (
  <Box>
   {/* hamburger-button */}
   <button
    onClick={() => setMenuOpen(!menuOpen)}
    className="border flex justify-center items-center p-1 lg:p-3"
   >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 19 19" fill="black">
     <path
      d="M3.19531 9.02246H16.6953"
      stroke=""
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
     />
     <path
      d="M3.19531 4.52197H16.6953"
      stroke=""
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
     />
     <path
      d="M3.19531 13.5225H16.6953"
      stroke=""
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
     />
    </svg>
   </button>
   <Box
    bg="highlight"
    className={` overflow-x-hidden absolute h-screen duration-700 left-0 right-0 top-[100px] bottom-0 ${
     menuOpen === true ? "w-[100%]" : "w-[0%]"
    }`}
   >
    <Box bg="background" className="flex gap-2 py-5 my-2 w-full">
     {/* SideBar button */}
     <button
      onClick={() => openSideBar()}
      className={` py-4 mx-1 w-1/2 z-30 relative ${
       sideBar === true ? "bg-yellow" : "bg-white text-black"
      }`}
     >
      Device Tree
     </button>
     {/* Navbar button */}
     <button
      onClick={() => openNav()}
      className={` py-4 mx-1 w-1/2 z-30 relative ${
       navbar === true ? "bg-yellow" : "bg-white text-black"
      }`}
     >
      Menu Navigation
     </button>
    </Box>
    {/* navbar component showing on navbar state true */}
    {navbar && (
     <div className="absolute z-10 h-screen top-0 pt-24 left-0 right-0 bottom-0 ">
      <Navbar />
     </div>
    )}
    {/* navbar component showing on SideBar state true */}
    {sideBar && (
     <div className="absolute z-10 h-screen top-8 pt-16 left-0 right-0 bottom-0 ">
      <SideBar />
     </div>
    )}
   </Box>
  </Box>
 )
}
